import { SitesConfigOptions } from 'common/models/Configuration/Sites';
import { ChangeTracker } from 'common/models/hooks/ChangeTracker';

export const DefaultOptions: SitesConfigOptions = {
  SiteDefaultSummary: '',
};

export const NoChangesTracker: ChangeTracker<SitesConfigOptions> = {
  SiteDefaultSummary: false,
};
